(()=>{
  function bindMenu(root=document){
    root.querySelectorAll('[data-srd-menu-toggle]').forEach(btn=>{
      if(btn.dataset.bound)return;
      btn.dataset.bound='1';
      btn.addEventListener('click',()=>{
        const nav=document.querySelector('[data-srd-mobile-nav]');
        if(!nav)return;
        const open=nav.hasAttribute('hidden');
        if(open)nav.removeAttribute('hidden');else nav.setAttribute('hidden','');
        btn.setAttribute('aria-expanded',open?'true':'false');
      });
    });
  }
  function bindFinder(root=document){
    root.querySelectorAll('[data-srd-finder]').forEach(form=>{
      if(form.dataset.finderBound)return;
      form.dataset.finderBound='1';
      form.addEventListener('submit',e=>{
        const model=form.querySelector('[data-srd-model]').value;
        const method=form.querySelector('[data-srd-method]').value;
        const size=form.querySelector('[data-srd-size]').value;
        const routes={'3x3|DTL':'/products/3x3-dtl-labels','3x3|TTL':'/products/3x3-ttl-labels','4x2|DTL':'/products/4x2-dtl-labels','4x2|TTL':'/products/4x2-ttl-labels'};
        const target=routes[size+'|'+method];
        if(target){e.preventDefault();window.location.assign(target);return;}
        form.querySelector('input[name=q]').value=[size,method,model].filter(Boolean).join(' ');
      });
    });
  }
  function bindFaq(root=document){
    root.querySelectorAll('[data-faq-button]').forEach(btn=>{
      if(btn.dataset.faqBound)return;
      btn.dataset.faqBound='1';
      let animation;
      btn.addEventListener('click',()=>{
        const row=btn.closest('[data-faq-row]');
        if(!row)return;
        const answer=row.querySelector('.srd-faq-answer');
        const from=answer?answer.getBoundingClientRect().height:0;
        if(animation)animation.cancel();
        const open=!row.classList.contains('is-open');
        row.classList.toggle('is-open',open);
        btn.setAttribute('aria-expanded',open?'true':'false');
        const marker=btn.querySelector('[data-faq-marker]');
        if(marker)marker.textContent=open?'−':'+';
        if(!answer)return;
        answer.inert=!open;
        if(!answer.animate||window.matchMedia('(prefers-reduced-motion: reduce)').matches){answer.style.removeProperty('display');return;}
        answer.style.display='block';
        const to=open?answer.getBoundingClientRect().height:0;
        const padding=window.getComputedStyle(answer);
        animation=answer.animate([{height:from+'px',paddingTop:open?'0px':padding.paddingTop,paddingBottom:open?'0px':padding.paddingBottom,opacity:open?0:1,overflow:'hidden'},{height:to+'px',paddingTop:open?padding.paddingTop:'0px',paddingBottom:open?padding.paddingBottom:'0px',opacity:open?1:0,overflow:'hidden'}],{duration:240,easing:'cubic-bezier(.2,.75,.25,1)'});
        animation.finished.then(()=>{answer.style.removeProperty('display');animation=null}).catch(()=>{});
      });
    });
  }
  function bindProduct(root=document){
    root.querySelectorAll('[data-srd-product]').forEach(section=>{
      const select=section.querySelector('[data-srd-variant-select]');
      if(!select||select.dataset.priceBound)return;
      select.dataset.priceBound='1';
      const quantity=section.querySelector('[data-srd-order-quantity]');
      const cards=section.querySelector('[data-srd-pack-choices]');
      const quickSpecs=section.querySelector('[data-srd-quick-specs]');
      if(quickSpecs&&window.matchMedia('(max-width:800px)').matches)quickSpecs.open=false;
      const requestedQuantity=Number(new URL(window.location.href).searchParams.get('guided_quantity'));
      if(quantity&&Number.isInteger(requestedQuantity)&&requestedQuantity>0)quantity.value=String(requestedQuantity);
      if(cards){
        cards.hidden=false;
        select.hidden=true;
        const label=section.querySelector('[data-srd-native-pack-label]');
        if(label)label.hidden=true;
        cards.querySelectorAll('[data-srd-pack-choice]').forEach(card=>card.addEventListener('click',()=>{
          select.value=card.dataset.srdPackChoice;
          select.dispatchEvent(new Event('change',{bubbles:true}));
        }));
      }
      const update=()=>{
        const option=select.selectedOptions[0];
        if(!option)return;
        const set=(selector,value)=>{const el=section.querySelector(selector);if(el)el.textContent=value||'';};
        set('[data-srd-current-price]',option.dataset.price);
        set('[data-srd-price-unit]',option.dataset.priceUnit);
        set('[data-srd-quantity-label]',option.dataset.quantityLabel);
        set('[data-srd-pack-note]',option.dataset.packNote);
        set('[data-srd-sku]',option.dataset.sku);
        const compare=section.querySelector('[data-srd-compare-price]');
        if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
        if(cards)cards.querySelectorAll('[data-srd-pack-choice]').forEach(card=>card.setAttribute('aria-pressed',String(card.dataset.srdPackChoice===select.value)));
        const count=quantity?Math.max(1,Math.floor(Number(quantity.value)||1)):1;
        const rollCount=Number(option.dataset.rollCount||1);
        section.querySelectorAll('[data-srd-price-row]').forEach(row=>row.dataset.active=String(row.dataset.srdPriceRow===select.value));
        section.querySelectorAll('[data-srd-guide-link]').forEach(link=>{
          const target=new URL(link.href,window.location.origin);
          const variant=rollCount===4?link.dataset.boxVariant:link.dataset.rollVariant;
          if(variant)target.searchParams.set('variant',variant);
          target.searchParams.set('guided_quantity',String(count));
          link.href=target.toString();
        });
        const summary=section.querySelector('[data-srd-order-summary]');
        if(summary){
          summary.hidden=false;
          const amount=Number(option.dataset.priceCents)*count/100;
          set('[data-srd-order-total]',new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:section.dataset.currency||'USD'}).format(amount));
          const rolls=count*rollCount;
          set('[data-srd-order-rolls]',rolls===1?summary.dataset.oneRollSummary:summary.dataset.rollsSummary.replace('SRD_COUNT',String(rolls)));
          const formattedLabels=new Intl.NumberFormat(document.documentElement.lang||'en-US').format(rolls*3000);
          set('[data-srd-order-labels]',(summary.dataset.labelsSummary||'').replace('SRD_COUNT',formattedLabels));
          const savings=section.querySelector('[data-srd-order-savings]');
          if(savings){
            const savingsCents=(Number(section.dataset.rollPriceCents)*rollCount-Number(option.dataset.priceCents))*count;
            savings.hidden=rollCount!==4||savingsCents<=0;
            const formattedSavings=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:section.dataset.currency||'USD'}).format(savingsCents/100);
            savings.textContent=(summary.dataset.savingsSummary||'').replace('SRD_SAVINGS',formattedSavings);
          }
        }
        const decrease=section.querySelector('[data-srd-quantity-step="-1"]');
        if(decrease)decrease.disabled=count<=1;
        const button=section.querySelector('[data-srd-add-button]');
        if(button){button.disabled=option.dataset.available!=='true'||Boolean(quantity&&!quantity.validity.valid);button.textContent=option.dataset.available==='true'?button.dataset.addLabel:button.dataset.soldLabel;}
      };
      select.addEventListener('change',()=>{
        update();
        const url=new URL(window.location.href);
        url.searchParams.set('variant',select.value);
        window.history.replaceState({},'',url);
      });
      if(quantity)quantity.addEventListener('input',update);
      section.querySelectorAll('[data-srd-quantity-step]').forEach(button=>button.addEventListener('click',()=>{
        if(!quantity)return;
        quantity.value=String(Math.max(1,Math.floor(Number(quantity.value)||1)+Number(button.dataset.srdQuantityStep)));
        quantity.dispatchEvent(new Event('input',{bubbles:true}));
      }));
      const productForm=select.closest('form');
      let pendingControls=[];
      const resetPending=()=>{
        if(!productForm)return;
        productForm.dataset.cartPending='false';
        productForm.removeAttribute('aria-busy');
        pendingControls.forEach(([control,disabled])=>{control.disabled=disabled});
        pendingControls=[];
        const button=section.querySelector('[data-srd-add-button]');
        if(button){button.removeAttribute('aria-busy');delete button.dataset.srdState;}
        const status=section.querySelector('[data-srd-cart-status]');
        if(status)status.textContent='';
        update();
      };
      if(productForm)window.addEventListener('pageshow',()=>{if(productForm.dataset.cartPending==='true')resetPending()});
      if(productForm)productForm.addEventListener('submit',async event=>{
        event.preventDefault();
        if(productForm.dataset.cartPending==='true'||!productForm.checkValidity())return;
        const button=section.querySelector('[data-srd-add-button]');
        const error=section.querySelector('[data-srd-cart-error]');
        const status=section.querySelector('[data-srd-cart-status]');
        const selectedId=Number(select.value);
        const selectedQuantity=Number(quantity?quantity.value:1);
        pendingControls=Array.from(productForm.querySelectorAll('input,select,button')).map(control=>[control,control.disabled]);
        productForm.dataset.cartPending='true';
        productForm.setAttribute('aria-busy','true');
        pendingControls.forEach(([control])=>{control.disabled=true});
        if(error)error.hidden=true;
        if(button){button.setAttribute('aria-busy','true');button.dataset.srdState='pending';button.textContent=error?error.dataset.addingLabel:button.dataset.addLabel;}
        if(status)status.textContent=button?button.textContent:'';
        try{
          const shopRoot=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
          const response=await fetch(shopRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:selectedId,quantity:selectedQuantity}]})});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||result.message||(error?error.dataset.errorLabel:''));
          productForm.removeAttribute('aria-busy');
          if(button){button.setAttribute('aria-busy','false');button.dataset.srdState='success';button.textContent=button.dataset.addedLabel;}
          if(status)status.textContent=button?button.textContent:'';
          if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches)await new Promise(resolve=>setTimeout(resolve,350));
          window.location.assign(shopRoot+'cart');
        }catch(failure){
          if(error){error.textContent=failure.message||error.dataset.errorLabel;error.hidden=false;}
          resetPending();
        }
      });
      update();
    });
  }
  function init(root=document){bindMenu(root);bindFinder(root);bindFaq(root);bindProduct(root);}
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();

